import axios from "axios";

export default class MenuAPI {
  constructor() {
    this.API_LINK = process.env.VUE_APP_API_LINK;
  }

  async getUploadedFiles(email) {
    try {
      const response = await axios({
        method: "get",
        //url: `${this.API_LINK}/uploadsAndLinks/`,
         url: `${this.API_LINK}/uploadsAndLinks/?email=${email}`
        // data: queries
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async postUploadedFile(data) {
    try {
      return await axios({
        method: "post",
        url: `${this.API_LINK}/uploadsAndLinks`,
        data,
      });
    } catch (error) {
      throw error.response;
    }
  }
}
